// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lt-3";
export var downloadButton = "_lt-4";
export var fileContainer = "_lt-9 _lt-7";
export var fileContainerBase = "_lt-7";
export var fileContainerFixedHeight = "_lt-8 _lt-7";
export var fileInfo = "_lt-5";
export var fileInfoWidthRestricted = "_lt-6";
export var fileType = "_lt-1";
export var fileTypeName = "_lt-2";
export var image = "_lt-0";
export var link = "_lt-b";
export var overflowEllipsis = "_lt-a";